import type { ReactNode } from 'react';

import type { IconDefinition } from '@sorare/core/src/atoms/icons';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';
import { css } from '@sorare/css';

const bar = css`
  &:is(&) {
    --active-bg-color: var(--c-nd-50);
    --active-fg-color: var(--c-white);
  }

  width: 100%;
  box-sizing: border-box;
  padding: 0 var(--container-padding, var(--double-unit));

  @media ${tabletAndAbove} {
    width: auto;
    padding: 0;
  }
`;

const onMobile = css`
  display: inline-flex;

  @media ${tabletAndAbove} {
    display: none;
  }
`;

const onDesktop = css`
  display: none;

  @media ${tabletAndAbove} {
    display: inline-flex;
  }
`;

export type MarketTab = {
  to: string;
  icon: IconDefinition;
  iconColor?: string;
  label: ReactNode;
  alwaysShowLabel?: boolean;
};

type Props = {
  tabs: MarketTab[];
};

export const MarketTabBar = ({ tabs }: Props) => (
  <TabBar variant="primary" fullWidth scrollable={false} className={bar}>
    {tabs.map(t => (
      <Tab key={t.to} to={t.to}>
        {t.alwaysShowLabel ? (
          <Horizontal gap={0.5} center>
            <FontAwesomeIcon icon={t.icon} fontSize={16} color={t.iconColor} />
            {t.label}
          </Horizontal>
        ) : (
          <>
            <span className={onMobile}>
              <FontAwesomeIcon icon={t.icon} fontSize={16} />
            </span>
            <span className={onDesktop}>{t.label}</span>
          </>
        )}
      </Tab>
    ))}
  </TabBar>
);
